import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./afla-module-status.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./afla-module-status.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from "@angular/core";
import { Router } from "@angular/router";
import { DashboardService } from "../shared/dashboard.service";
import { AflaModuleStatus } from "../shared/module-status.model";
import { AppControllerService } from "../../../app-controller.service";
import { SharedConstants } from "../../../shared/constants/shared.constants";
import { AppRoutingConstants } from "../../../app-routing.constants";
import { ApplicationsRoutingConstants } from "../../../tabs/applications/applications-routing.constants";
let AflaModuleStatusComponent = class AflaModuleStatusComponent {
    router;
    changeDetector;
    appService;
    dashbordSerice;
    moduleStatusP;
    moduleP;
    constructor(router, changeDetector, appService, dashbordSerice) {
        this.router = router;
        this.changeDetector = changeDetector;
        this.appService = appService;
        this.dashbordSerice = dashbordSerice;
    }
    get moduleStatus() {
        return this.moduleStatusP;
    }
    set moduleStatus(vl) {
        this.moduleStatusP = vl;
    }
    get module() {
        return this.moduleP;
    }
    set module(vl) {
        this.moduleP = vl;
    }
    ngOnInit() {
    }
    filterApplication(applicationStatus) {
        if (applicationStatus === AflaModuleStatus.Overdue)
            applicationStatus = SharedConstants.DASHBOARD_FILTERS.OverdueApplications;
        else if (applicationStatus === AflaModuleStatus.Remaining)
            applicationStatus = SharedConstants.DASHBOARD_FILTERS.LatestApplications;
        this.dashbordSerice.filterApplicationBehaviour.next(applicationStatus);
        this.appService.setSelectedModule(this.module.id);
        this.router.navigate([AppRoutingConstants.ROUTE_SEPERATOR +
                this.appService.selectedModuleID + AppRoutingConstants.ROUTE_SEPERATOR +
                ApplicationsRoutingConstants.APPLICATIONS_ROUTE]);
    }
    static ctorParameters = () => [
        { type: Router },
        { type: ChangeDetectorRef },
        { type: AppControllerService },
        { type: DashboardService }
    ];
    static propDecorators = {
        moduleStatus: [{ type: Input }],
        module: [{ type: Input }]
    };
};
AflaModuleStatusComponent = __decorate([
    Component({
        selector: "app-afla-module-status",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], AflaModuleStatusComponent);
export { AflaModuleStatusComponent };
